import './header.scss';
import { Link } from 'react-router-dom';
// import {Modal} from '@photocarbone/nooco-ui';
// import Modal from '@photocarbone/nooco-ui/components';
import { Button, Dropdown } from '@photocarbone/nooco-ui';
import { ModalNooco } from '@photocarbone/nooco-ui';
import { StateDTO } from '../../../models/GeneralDTO';
import { TextField } from '@mui/material';
import {
  updateFormValue,
  updateProjectsListMonitoring,
} from '../../../../actions/projects';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocalStorage } from 'react-use';
import { useTranslation } from 'react-i18next';
import AddIcon from '@material-ui/icons/Add';
import InputAdornment from '@material-ui/core/InputAdornment';
import NoocoCheckbox from '../../../shared/NoocoCheckbox';
import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import Tooltip from '@material-ui/core/Tooltip';
import useCase from '../useCase/useCase';

export const Header = ({ onClick }) => {
  const {
    licenceTypeAccess,
    companyFilters,
    parentCompanies,
    structuredCompanies,
    projectInput,
    isSuperAdmin,
  } = useSelector((state: StateDTO) => state.projects);
  const { arianeCompany, mappingProject, dropDownInput, projectTypeFilter } =
    useSelector((state: StateDTO) => state.projects.projectsListMonitoring);
  const isUserProAccess = licenceTypeAccess === 'pro';
  const hasChildrenCompany = !!arianeCompany.selectedCompanyId;
  const { selectDropDownCompany, selectHomeBreadCrumb } = useCase();
  const [displayCreationModalInformation, setDisplayCreationModalInformation] =
    useLocalStorage('displayCreationModalInformation', true);
  const [isModalCreationProjectOpen, setIsModalCreationProjectOpen] =
    useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  // useEffect(() => {

  // }, [])

  const mappingTooltip = () => {
    if (!isUserProAccess) {
      return t('APP.HEADER.HEADER.PH_665F8C', {
        defaultValue: 'Fonctionnalité disponible avec une licence pro seulement',
      });
    }
    if (!hasChildrenCompany) {
      return t('APP.HEADER.HEADER.PH_2747F7', {
        defaultValue:
          'Vous devez selectionner une entreprise pour activer cette fonctionnalité',
      });
    }
    if (isEnglishLanguage) {
      return t('APP.RIGHTS.RIGHTS.PH_65A3E8', {
        defaultValue: 'Bientôt disponble',
      });
    }

    return '';
  };

  const projectTypeFilterTooltip = () => {
    if (projectTypeFilter.length === 0) {
      return t('APP.HEADER.HEADER.PH_C9686C', {
        defaultValue: 'Aucun type de projet filtré',
      });
    }

    if (projectTypeFilter.length === 1) {
      return `${t('APP.HEADER.HEADER.PH_EAACC6', {
        defaultValue: 'Type de projet filtré :',
      })} ${projectTypeFilter[0].name}`;
    }

    let projectTypeFilterNames = t('APP.HEADER.HEADER.PH_420A39', {
      defaultValue: 'Les types de projets filtrés sont :',
    });

    projectTypeFilter.forEach((project) => {
      projectTypeFilterNames += project.name + ', ';
    });

    return projectTypeFilterNames.slice(0, projectTypeFilterNames.length - 2);
  };
  const isEnglishLanguage = i18n.language === 'en-GB';

  const mappingClassName = () => {
    let mappingClassName = 'referenceMappingButton';

    if (!isUserProAccess || !hasChildrenCompany || isEnglishLanguage) {
      mappingClassName = 'referenceMappingButton disabled';
    }

    return mappingClassName;
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (projectInput === '') {
      // console.log("j'efface les projects list");
      dispatch(updateFormValue('projectsList', []));
    }

    // if (dropDownInput !== undefined) {
    //   dispatch(updateProjectsListMonitoring('dropDownInput',
    //   undefined));
    // }
  }, [projectInput]);

  const handleOnChangeDropdown = (value) => {
    // console.log('onChange')
    // console.log('value', value)
  };
  const handleOnSelectDropdown = (companyId, company) => {
    // console.log('onSelect')
    // console.log('companyId', companyId)
    selectDropDownCompany(companyId, company);
    // console.log('company from dropown', company)
  };
  const handleOnClearDropdown = () => {
    selectHomeBreadCrumb();
  };
  const DropDownArgs = {
    onChange: handleOnChangeDropdown,
    onSelect: handleOnSelectDropdown,
    options: structuredCompanies,
    value: dropDownInput,
    style: { width: '300px', borderRadius: '15px' },
    dropdownStyle: { maxHeight: 400, overflow: 'auto' },
    treeNodeFilterProp: 'title',
    multiple: false,
    treeCheckable: false,
    showSearch: true,
    onClear: handleOnClearDropdown,
    colorScheme: 'green',
  };

  const handleCloseModal = () => {
    setDisplayCreationModalInformation(true);
    setIsModalCreationProjectOpen(false);
  };

  const handleCreateProject = () => {
    history.push('/creation/project');
  };

  return (
    <div className="headerWrapper">
      {/* Differents Modal */}
      <ModalNooco
        isOpen={isModalCreationProjectOpen}
        title={t('APP.HEADER.HEADER.PH_7965CC', {
          defaultValue: 'Création de projet',
        })}
        closeIcon={false}
        closeOnOutsideClick={false}
        cancelFunction={handleCloseModal}
        validateFunction={handleCreateProject}
      >
        <>
          <div>
            {t('APP.HEADER.HEADER.PH_64B6A7', {
              defaultValue:
                "La création de votre projet s'effectuera au niveau de l'arborescence sur lequel vous vous trouvez.",
            })}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <NoocoCheckbox
              checked={!displayCreationModalInformation}
              onClick={() =>
                setDisplayCreationModalInformation(!displayCreationModalInformation)
              }
            />

            <div style={{ marginLeft: '1rem' }}>
              {t('APP.HEADER.HEADER.PH_AC6A93', {
                defaultValue: 'Ne plus afficher ce message',
              })}
            </div>
          </div>
        </>
      </ModalNooco>

      {/* headerLogo */}
      <div className="headerLogo">
        {t('APP.HEADER.HEADER.PH_3EF82D', { defaultValue: 'Projets en cours' })}
      </div>

      {/* headerNav */}
      <div className="headerNav">
        {/* INPUT SEARCH COMPANY */}
        {isSuperAdmin && <Dropdown {...DropDownArgs} />}
        {/* INPUT SEARCH PROJECT */}
        <Tooltip
          title={
            isSuperAdmin
              ? ''
              : t('APP.HEADER.HEADER.PH_25FFC9', {
                  defaultValue:
                    'Effectuer une recherche sur tous vos projets/responsables (tous dossiers confondus)',
                })
          }
        >
          <div className="searchProjectWrapper">
            <TextField
              placeholder={t('APP.HEADER.HEADER.PH_DE6D21', {
                defaultValue: 'Rechercher un projet ou un responsable',
              })}
              className="textFieldV1 searchProject"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                dispatch(updateFormValue('projectInput', e.target.value));
              }}
              value={projectInput}
            />
          </div>
        </Tooltip>
        {/* PROJECT TYPE FILTER */}
        <Tooltip title={projectTypeFilterTooltip()}>
          <div className="projectTypeFilterWrapper">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.6678 18.7705L22.4589 17.8441C22.4815 17.652 22.5041 17.4712 22.5041 17.2791C22.5041 17.0871 22.4928 16.9063 22.4589 16.7142L23.6565 15.7878C23.7073 15.7443 23.7417 15.6847 23.754 15.619C23.7663 15.5532 23.7559 15.4852 23.7243 15.4263L22.5945 13.4717C22.5267 13.3248 22.3798 13.3248 22.233 13.3248L20.8433 13.8897C20.5383 13.6864 20.2332 13.4943 19.883 13.3587L19.6683 11.8674C19.6612 11.803 19.6309 11.7434 19.5831 11.6998C19.5353 11.6561 19.4732 11.6314 19.4085 11.6301H17.1488C17.0798 11.6288 17.0125 11.6519 16.9588 11.6953C16.9051 11.7387 16.8684 11.7996 16.8551 11.8674L16.6404 13.3587C16.3015 13.5056 15.9738 13.6864 15.6801 13.8897L14.2791 13.3248C14.1548 13.3248 14.008 13.3248 13.9289 13.4717L12.7991 15.4263C12.7313 15.5505 12.7539 15.6974 12.8669 15.7878L14.0645 16.7142C14.0194 17.0895 14.0194 17.4688 14.0645 17.8441L12.8669 18.7705C12.8161 18.814 12.7817 18.8736 12.7694 18.9393C12.7571 19.0051 12.7675 19.0731 12.7991 19.132L13.9289 21.0866C13.9967 21.2335 14.1435 21.2335 14.2791 21.2335L15.6801 20.6686C15.9738 20.8719 16.2902 21.064 16.6404 21.1996L16.8551 22.6909C16.8777 22.8265 16.9907 22.9282 17.1488 22.9282H19.4085C19.5327 22.9282 19.657 22.8265 19.6796 22.6909L19.8943 21.1996C20.2332 21.0527 20.5383 20.8719 20.8433 20.6686L22.233 21.2335C22.3798 21.2335 22.5267 21.2335 22.6058 21.0866L23.7356 19.132C23.7672 19.0731 23.7776 19.0051 23.7653 18.9393C23.753 18.8736 23.7186 18.814 23.6678 18.7705ZM18.2786 18.9739C17.3296 18.9739 16.5839 18.2169 16.5839 17.2791C16.5839 16.3414 17.3409 15.5844 18.2786 15.5844C19.2164 15.5844 19.9734 16.3414 19.9734 17.2791C19.9734 18.2169 19.2164 18.9739 18.2786 18.9739ZM17.8493 0.580589C17.6347 0.422416 17.3974 0.332031 17.1488 0.332031H1.33153C1.08297 0.332031 0.845712 0.422416 0.631049 0.580589C0.39654 0.765365 0.244702 1.03545 0.208713 1.33183C0.172723 1.62821 0.25551 1.92679 0.438981 2.16232L5.85076 9.08804V14.8727C5.80557 15.2003 5.91855 15.5505 6.1784 15.8104L10.7089 20.3409C10.8219 20.4539 10.9349 20.533 11.1044 20.5895C10.6185 19.5388 10.37 18.409 10.37 17.2791C10.37 15.2116 11.1835 13.2231 12.6296 11.7431V9.08804L18.0414 2.16232C18.2249 1.92679 18.3076 1.62821 18.2717 1.33183C18.2357 1.03545 18.0838 0.765365 17.8493 0.580589ZM10.37 8.29718V16.8046L8.11038 14.545V8.30847L3.63634 2.59165H14.844L10.37 8.29718Z"
                fill="#A3AED0"
              />
            </svg>
            <div
              className={`tag ${projectTypeFilter.length === 0 ? 'disabled' : ''}`}
            >
              {projectTypeFilter.length}
            </div>
          </div>
        </Tooltip>

        {/* MAPPING DE REF */}
        <Tooltip title={mappingTooltip()}>
          <div
            className={mappingClassName()}
            onClick={() => {
              if (mappingProject && !isEnglishLanguage) {
                onClick(mappingProject);
              }
            }}
          >
            <svg
              width="19"
              height="22"
              viewBox="0 0 21 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M2.89286 1.44643C2.89286 0.646373 2.24648 0 1.44643 0C0.646373 0 0 0.646373 0 1.44643V21.6964C0 22.4965 0.646373 23.1429 1.44643 23.1429C2.24648 23.1429 2.89286 22.4965 2.89286 21.6964V15.9107L5.79927 15.183C7.65703 14.7174 9.62327 14.9344 11.3364 15.7887C13.3343 16.7876 15.6531 16.9097 17.7414 16.1232L19.3098 15.5355C19.8748 15.3231 20.25 14.7852 20.25 14.1795V2.98778C20.25 1.94816 19.1561 1.27015 18.225 1.73571L17.7911 1.95268C15.6983 3.00134 13.2348 3.00134 11.142 1.95268C9.55547 1.15714 7.73387 0.958259 6.01172 1.38767L2.89286 2.16964V1.44643Z" />
            </svg>
            <div>
              {t('APP.HEADER.HEADER.PH_9751D3', {
                defaultValue: 'Mapping de référence',
              })}
            </div>
          </div>
        </Tooltip>

        {/* CREATE PROJECT */}

        {isUserProAccess && (
          <Button
            additionalIcon={<AddIcon />}
            className="purple-button"
            text={t('APP.HEADER.HEADER.PH_B2FF12', {
              defaultValue: 'Nouveau Projet',
            })}
            onClick={() => {
              if (displayCreationModalInformation) {
                setIsModalCreationProjectOpen(true);
              } else {
                handleCreateProject();
              }
            }}
          />
        )}

        {!isUserProAccess && (
          <Tooltip
            title={t('APP.HEADER.HEADER.PH_81F561', {
              defaultValue:
                'Fonctionnalité disponible avec une licence pro seulement',
            })}
          >
            <Button
              additionalIcon={<AddIcon />}
              className="purple-button"
              onClick={() => {}}
              text={t('APP.HEADER.HEADER.PH_089C87', {
                defaultValue: 'Nouveau Projet',
              })}
              disabled={true}
            />

            {/* <div
            className={"newProjectButton disabled"}
            > 
            <AddIcon />
            <div>
            Nouveau Projet
            </div>
            </div> */}
          </Tooltip>
        )}
      </div>
    </div>
  );
};
